import { useCallback, useState } from "react"
import type { KeyboardEvent } from "react"

import styles from "./AccountingGroupForm.module.scss"

type Props = {
	emails: string[]
	onChange: (emails: string[]) => void
	error?: string
}

const BillingEmailsInput = ({ emails, onChange, error }: Props) => {
	const [inputValue, setInputValue] = useState("")

	const addEmail = useCallback(() => {
		const trimmed = inputValue.trim()
		if (trimmed && !emails.includes(trimmed)) {
			onChange([...emails, trimmed])
		}
		setInputValue("")
	}, [inputValue, emails, onChange])

	const handleKeyDown = useCallback(
		(e: KeyboardEvent<HTMLInputElement>) => {
			if (e.key === "Enter") {
				e.preventDefault()
				addEmail()
			}
			if (e.key === "Backspace" && inputValue === "" && emails.length > 0) {
				onChange(emails.slice(0, -1))
			}
		},
		[addEmail, inputValue, emails, onChange]
	)

	const removeEmail = useCallback(
		(index: number) => {
			onChange(emails.filter((_, i) => i !== index))
		},
		[emails, onChange]
	)

	return (
		<div className={styles.field}>
			<label className={styles.label}>明細・請求書送付先メールアドレス</label>
			<div
				className={`${styles.tag_input_container} ${error ? styles.input_error : ""}`}
			>
				{emails.map((email, index) => (
					<span key={index} className={styles.tag}>
						{email}
						<button
							type="button"
							className={styles.tag_remove}
							onClick={() => removeEmail(index)}
						>
							&times;
						</button>
					</span>
				))}
				<input
					type="email"
					value={inputValue}
					onChange={(e) => setInputValue(e.target.value)}
					onKeyDown={handleKeyDown}
					onBlur={addEmail}
					placeholder={emails.length === 0 ? "sample@example.com" : ""}
					className={styles.tag_text_input}
				/>
			</div>
			{error && <span className={styles.error_message}>{error}</span>}
		</div>
	)
}

export default BillingEmailsInput
